function showMain() {
	new TimelineMax({
		onStart() {
			window.scrollTo(0, 0);

			$('.site-container').removeClass('is-hidden');
		},
	})
		.from($('.site-container'), 0.7, {
			autoAlpha: 0,
			clearProps: 'all',
		}, 0.5);
}

function showInner() {
	// eslint-disable-next-line no-new
	new TimelineMax({
		onStart() {
			window.scrollTo(0, 0);

			$('.site-container').removeClass('is-hidden');
		},
	})
		.from($('.site-container'), 0.7, {
			autoAlpha: 0,
			clearProps: 'all',
		}, 0.5);
}

if (location.href.indexOf('article') === -1) {
	showMain();
} else {
	showInner();
}
